import { routesAvailableWhenNotActive } from './constants';
import { useRouteMatch } from './useRouteMatch';

export function useIsRouteAvailableWhenNotActive() {
  return useRouteMatch(routesAvailableWhenNotActive) !== null;
}
